import styled from "styled-components";

export const Container = styled.div`
  min-height: calc(100vh - 55px);
  background: transparent;
  padding: 20px;
`;

export const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 600;
  color: #203b34;
  margin-bottom: 30px;
  text-align: center;
`;

export const SettingCard = styled.div`
  background: #ffffff;
  border: 1px solid #203b34;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 7px 7px 16px -4px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 7px 6px 16px -4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 7px 6px 16px -4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 7px 12px 20px -4px rgba(0, 0, 0, 0.15);
    border-color: #f9ae17;
  }
`;

export const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 50px;
  max-width: 40%;
  margin: 0 auto;
`;

export const CardIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  background: #203b34;
  border-radius: 50%;
  margin: 0 auto 20px;
  color: #f9ae17;
  font-size: 1.8rem;
  transition: all 0.3s ease;

  ${SettingCard}:hover & {
    background: #f9ae17;
    color: #203b34;
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #203b34;
  text-align: center;
  margin-bottom: 15px;
`;

export const CardDescription = styled.p`
  font-size: 0.9rem;
  color: #666;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 20px;
`;

export const CardButton = styled.button`
  width: 100%;
  background: transparent;
  border: 2px solid #203b34;
  color: #203b34;
  padding: 12px 20px;
  border-radius: 5px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #203b34;
    color: #ffffff;
  }

  ${SettingCard}:hover & {
    border-color: #f9ae17;
    color: #f9ae17;

    &:hover {
      background: #f9ae17;
      color: #203b34;
    }
  }
`;

export const UserInfoSection = styled.div`
  background: #f7f7f7;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #e0e0e0;
`;

export const UserInfoTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 600;
  color: #203b34;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

export const UserInfoIcon = styled.i`
  margin-right: 10px;
  color: #f9ae17;
  font-size: 1.2rem;
`;

export const UserInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
`;

export const UserInfoItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserInfoLabel = styled.span`
  font-size: 0.8rem;
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 5px;
`;

export const UserInfoValue = styled.span`
  font-size: 1rem;
  color: #203b34;
  font-weight: 600;
`;

export const ComingSoonBadge = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: #f9ae17;
  color: #203b34;
  padding: 4px 8px;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
`;

export const DisabledCard = styled(SettingCard)`
  opacity: 0.6;
  cursor: not-allowed;
  position: relative;

  &:hover {
    transform: none;
    box-shadow: 7px 7px 16px -4px rgba(0, 0, 0, 0.1);
    border-color: #203b34;
  }
`;

export const SignatureStatusBadge = styled.div`
  position: absolute;

  background: ${({ $isRegistered }) => ($isRegistered ? "#28a745" : "#f9ae17")};
  color: white;
  padding: 4px 8px;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100px;
  top: 10px;
  right: 10px;
`;

export const SignatureStatusText = styled.div`
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  background: ${({ $isRegistered }) => ($isRegistered ? "#d4edda" : "#fff3cd")};
  color: ${({ $isRegistered }) => ($isRegistered ? "#155724" : "#856404")};
  border: 1px solid
    ${({ $isRegistered }) => ($isRegistered ? "#c3e6cb" : "#ffeeba")};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;
